let timer = null;
$(document).on('input', '.js-product-search', function() {
    clearTimeout(timer);
    let search_input = $(this);
    timer = setTimeout(function() {

        let search_string = search_input.val();
        if(search_string.length > 3){

            $('.search-button').data('default-html', $('.search-button').html());
            $('.search-button').html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');

            let data_to_send = {
                action: 'search',
                search_string: search_string
            };

            jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data_to_send, function(response) {
                if(response){
                    show_overlay('search-overlay');
                    $('.js-search-suggest-wrapper').html(response).fadeIn();
                    search_input.addClass('has-response');
                    $('.search-form').addClass('suggest-active');
                    $('.search-button').html($('#search_button').data('default-html'));
                }
            })
        }else{
            if(!search_input.hasClass('js-mobile-search-input')){
                hide_overlay();
            }
            $('.js-product-search').removeClass('has-response')
        }
    },
    800);
});

$(document).on('focus click','.js-product-search.has-response', function(){
    show_overlay('search-overlay');
    $('.js-search-suggest-wrapper').fadeIn();
})
